import { h } from "common/dom-builder";

export function iconButton(name) {
  return h("span", { class: ["icon-button", `${name}-button`] });
}

export function smallIconButton(name) {
  return h("span", { class: ["icon-button", "sm", `${name}-button`] });
}
